import { supabase } from "@/lib/supabase";

export async function submitFeedback({ user_id, category, subject, message, screenshot_url }) {
  const row = {
    user_id: user_id || null,
    category,
    subject: subject.trim(),
    message: message.trim(),
    screenshot_url: screenshot_url || null,
  };
  const { error } = await supabase.from("feedback").insert(row);
  if (error) throw error;
  return true;
}

export async function listFeedback({ status, q } = {}) {
  let query = supabase
    .from("feedback")
    .select(
      "id, user_id, category, subject, message, screenshot_url, status, created_at"
    )
    .order("created_at", { ascending: false });
  if (status && status !== "all") query = query.eq("status", status);
  if (q) {
    const like = `%${q}%`;
    query = query.or(`subject.ilike.${like},message.ilike.${like}`);
  }
  const { data, error } = await query;
  if (error) throw error;
  // Best-effort fetch the reporter handle for display. RLS for profiles
  // allows admin reads via the existing v7 policy.
  const ids = [...new Set((data || []).map((r) => r.user_id).filter(Boolean))];
  let byId = {};
  if (ids.length) {
    const { data: profiles } = await supabase
      .from("profiles")
      .select("id, username, display_name, avatar_url")
      .in("id", ids);
    byId = Object.fromEntries((profiles || []).map((p) => [p.id, p]));
  }
  return (data || []).map((r) => ({ ...r, reporter: byId[r.user_id] || null }));
}

export async function updateFeedbackStatus(id, status) {
  const { error } = await supabase
    .from("feedback")
    .update({ status })
    .eq("id", id);
  if (error) throw error;
}

export async function countOpenFeedback() {
  const { count, error } = await supabase
    .from("feedback")
    .select("id", { count: "exact", head: true })
    .eq("status", "open");
  if (error) return 0;
  return count || 0;
}

// Optional screenshot upload helper.
export async function uploadFeedbackScreenshot(file, userId) {
  if (!file || !userId) return null;
  const ext = (file.name.split(".").pop() || "png").toLowerCase().replace(/[^a-z0-9]/g, "") || "png";
  const path = `${userId}/${Date.now()}-${Math.random().toString(36).slice(2, 8)}.${ext}`;
  const { error } = await supabase.storage.from("feedback-screenshots").upload(path, file, {
    cacheControl: "3600", upsert: false, contentType: file.type || "image/png",
  });
  if (error) throw error;
  const { data } = supabase.storage.from("feedback-screenshots").getPublicUrl(path);
  return data.publicUrl;
}
